import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ToolTypeField } from '../../../commons/ui/fields/ToolTypeField';
import { AddMarkingToolBl } from '../../AddMarkingTool.bl';
import { IAddMarkingToolStore } from '../../AddMarkingTool.store';

export const ToolTypeFieldContainer = observer((): ReactElement => {
  const bl = useInjection(AddMarkingToolBl.$);
  const store = useInjection(IAddMarkingToolStore.$);

  return (
    <ToolTypeField
      onChangeToolType={bl.changeToolType}
      toolType={store.toolType}
    />
  );
});
